import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.visible}}
  <div class="card-content">
    {{#if this.loading}}
      <div class="card-row first-row">
        <div class="group-card-avatar">
          <div
            class="card-avatar-placeholder animated-placeholder placeholder-animation"
          ></div>
        </div>
      </div>

      <div class="card-row second-row">
        <div class="animated-placeholder placeholder-animation"></div>
      </div>
    {{else}}
      <div class="card-row first-row">
        <div class="group-card-avatar">
          <a
            {{on "click" this.handleShowGroup}}
            href={{this.groupPath}}
            class="card-huge-avatar"
          >
            <AvatarFlair
              @flairName={{this.group.name}}
              @flairUrl={{this.group.flair_url}}
              @flairBgColor={{this.group.flair_bg_color}}
              @flairColor={{this.group.flair_color}}
            />
          </a>
        </div>
        <div class="names">
          <span>
            <h1 class={{this.group.name}}>
              <a
                {{on "click" this.handleShowGroup}}
                href={{this.groupPath}}
                class="group-page-link"
              >{{this.group.name}}</a>
            </h1>
            {{#if this.group.full_name}}
              <h2 class="full-name">{{this.group.full_name}}</h2>
            {{else}}
              <h2 class="username">{{this.group.name}}</h2>
            {{/if}}
          </span>
        </div>
        <ul class="usercard-controls group-details-button">
          <li>
            <GroupMembershipButton
              @model={{this.group}}
              @showLogin={{route-action "showLogin"}}
            />
          </li>
          {{#if this.group.messageable}}
            <li>
              <DButton
                @action={{action "messageGroup"}}
                @icon="envelope"
                @label="groups.message"
                class="btn-primary group-message-button inline"
              />
            </li>
          {{/if}}
        </ul>
      </div>

      {{#if this.group.bio_excerpt}}
        <div class="card-row second-row">
          <div class="bio">
            {{html-safe this.group.bio_excerpt}}
          </div>
        </div>
      {{/if}}

      {{#if this.group.members}}
        <div class="card-row third-row">
          <div class="members metadata">
            {{#each this.highlightedMembers as |user|}}
              <a
                {{on "click" this.close}}
                href={{user.path}}
                class="card-tiny-avatar"
              >{{bound-avatar user "tiny"}}</a>
            {{/each}}
            {{#if this.showMoreMembers}}
              <a
                {{on "click" this.handleShowGroup}}
                href={{this.groupPath}}
                class="more-members-link"
              >
                <span class="more-members-count">+{{this.moreMembersCount}}
                  {{i18n "more"}}</span>
              </a>
            {{/if}}
          </div>
        </div>
      {{/if}}
    {{/if}}
  </div>
{{/if}}
*/
{
  "id": "BbAIbwv2",
  "block": "[[[41,[30,0,[\"visible\"]],[[[1,\"  \"],[10,0],[14,0,\"card-content\"],[12],[1,\"\\n\"],[41,[30,0,[\"loading\"]],[[[1,\"      \"],[10,0],[14,0,\"card-row first-row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"group-card-avatar\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"card-avatar-placeholder animated-placeholder placeholder-animation\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"card-row second-row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"animated-placeholder placeholder-animation\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"card-row first-row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"group-card-avatar\"],[12],[1,\"\\n          \"],[11,3],[16,6,[30,0,[\"groupPath\"]]],[24,0,\"card-huge-avatar\"],[4,[38,1],[\"click\",[30,0,[\"handleShowGroup\"]]],null],[12],[1,\"\\n            \"],[8,[39,2],null,[[\"@flairName\",\"@flairUrl\",\"@flairBgColor\",\"@flairColor\"],[[30,0,[\"group\",\"name\"]],[30,0,[\"group\",\"flair_url\"]],[30,0,[\"group\",\"flair_bg_color\"]],[30,0,[\"group\",\"flair_color\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"names\"],[12],[1,\"\\n          \"],[10,1],[12],[1,\"\\n            \"],[10,\"h1\"],[15,0,[30,0,[\"group\",\"name\"]]],[12],[1,\"\\n              \"],[11,3],[16,6,[30,0,[\"groupPath\"]]],[24,0,\"group-page-link\"],[4,[38,1],[\"click\",[30,0,[\"handleShowGroup\"]]],null],[12],[1,[30,0,[\"group\",\"name\"]]],[13],[1,\"\\n            \"],[13],[1,\"\\n\"],[41,[30,0,[\"group\",\"full_name\"]],[[[1,\"              \"],[10,\"h2\"],[14,0,\"full-name\"],[12],[1,[30,0,[\"group\",\"full_name\"]]],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,\"h2\"],[14,0,\"username\"],[12],[1,[30,0,[\"group\",\"name\"]]],[13],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"usercard-controls group-details-button\"],[12],[1,\"\\n          \"],[10,\"li\"],[12],[1,\"\\n            \"],[8,[39,3],null,[[\"@model\",\"@showLogin\"],[[30,0,[\"group\"]],[28,[37,4],[\"showLogin\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[30,0,[\"group\",\"messageable\"]],[[[1,\"            \"],[10,\"li\"],[12],[1,\"\\n              \"],[8,[39,5],[[24,0,\"btn-primary group-message-button inline\"]],[[\"@action\",\"@icon\",\"@label\"],[[28,[37,6],[[30,0],\"messageGroup\"],null],\"envelope\",\"groups.message\"]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"group\",\"bio_excerpt\"]],[[[1,\"        \"],[10,0],[14,0,\"card-row second-row\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"bio\"],[12],[1,\"\\n            \"],[1,[28,[35,7],[[30,0,[\"group\",\"bio_excerpt\"]]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"group\",\"members\"]],[[[1,\"        \"],[10,0],[14,0,\"card-row third-row\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"members metadata\"],[12],[1,\"\\n\"],[42,[28,[37,9],[[28,[37,9],[[30,0,[\"highlightedMembers\"]]],null]],null],null,[[[1,\"              \"],[11,3],[16,6,[30,1,[\"path\"]]],[24,0,\"card-tiny-avatar\"],[4,[38,1],[\"click\",[30,0,[\"close\"]]],null],[12],[1,[28,[35,10],[[30,1],\"tiny\"],null]],[13],[1,\"\\n\"]],[1]],null],[41,[30,0,[\"showMoreMembers\"]],[[[1,\"              \"],[11,3],[16,6,[30,0,[\"groupPath\"]]],[24,0,\"more-members-link\"],[4,[38,1],[\"click\",[30,0,[\"handleShowGroup\"]]],null],[12],[1,\"\\n                \"],[10,1],[14,0,\"more-members-count\"],[12],[1,\"+\"],[1,[30,0,[\"moreMembersCount\"]]],[1,\"\\n                  \"],[1,[28,[35,11],[\"more\"],null]],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"user\"],false,[\"if\",\"on\",\"avatar-flair\",\"group-membership-button\",\"route-action\",\"d-button\",\"action\",\"html-safe\",\"each\",\"-track-array\",\"bound-avatar\",\"i18n\"]]",
  "moduleName": "discourse/components/group-card-contents.hbs",
  "isStrictMode": false
});